

import { Box, Card, CardContent, Typography, useMediaQuery, Dialog, Divider, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { IconButton, Menu, MenuItem, Button } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import noRecordImage from './no_tailorperformances.png';
import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, doc, deleteDoc, getDocs,setDoc, writeBatch, updateDoc,addDoc, query, where } from 'firebase/firestore';
import {db} from '../../firebaseConfig';
import {generateUniqueId} from '../../common/ItemNumberGenerator'; 

import Tile from './TailorPerformanceTile';

import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';

import backgroundImage from './../../images/application-bg-images/app-bg-image.png';
import backgroundImageMobile from './../../images/application-bg-images/app-bg-image-mobile.png';

import TailorPerformanceInputModal from './TailorPerformanceInputModal';
import TailorPerformanceDrawerModal from './TailorPerformanceDrawerModal';

import { styled } from '@mui/material/styles';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';

import { logToast } from '../../common/ToastMessageLogger';

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";









const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};

const stringToColorDark = (str) => {
  
  return stringToColorLight(str); // We will use the same colors
};

const stringToColorDarkOLD = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always dark by restricting them to the first half of 256
    const darkValue = value % 128;
    color += ('00' + darkValue.toString(16)).substr(-2);
  }
  return color;
};


const TailorPerformances = ({ searchTerm }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode(); 

  const [tailorPerformances, setTailorPerformances] = useState([]);
  const [staffMap, setStaffMap] = useState({});
 

  const tilesDisplayCount = 6;

  const [visibleCount, setVisibleCount] = useState(tilesDisplayCount);

  const [showModal, setShowModal] = useState(false);
  const [editingTailorPerformance, setEditingTailorPerformance] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [collectionModalOpen, setCollectionModalOpen] = useState(false);
  const [missingCollections, setMissingCollections] = useState([]);
  const [deleteSelectionModel, setDeleteSelectionModel] = useState([]);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedTailorPerformance, setSelectedTailorPerformance] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  const [dependenciesAlertOpen, setDependenciesAlertOpen] = useState(false);

  const [deletionDependencies, setDeletionDependencies] = useState([]);

  const [selectedIdsToDelete, setSelectedIdsToDelete] = useState([]);
  const [selectedIdsNotToDelete, setSelectedIdsNotToDelete] = useState([]);

  const [processing, setProcessing] = useState(false);

  const [showTestModeDialog, setShowTestModeDialog] = useState(false);

  const [suppressTestModeWarning, setSuppressTestModeWarning] = useState(
    localStorage.getItem('suppressTestModeSaveWarning') === 'true'
  );

  







  	const columns = [
	{ field: "staffId", headerName: "Staff", flex: 1, valueFormatter: params => formatStaff(params.value) },
	{ field: "ordersCompleted", headerName: "Orders Completed", flex: 1},
	{ field: "qualityScore", headerName: "Quality Score", flex: 1},
	{ field: "timelinessScore", headerName: "Timeliness Score", flex: 1},
	{ field: "averageDailyOutput", headerName: "Average Daily Output (garments)", flex: 1},
	{ field: "customerFeedbackScore", headerName: "Customer Feedback Score", flex: 1},
	{ field: "actions", headerName: "Actions", sortable: false, filterable: false, width: 100, renderCell: params => <GridActionsCellItem {...params} /> }];



  const filteringColumns = [
	{ field: "staffId", headerName: "Staff"},
	{ field: "ordersCompleted", headerName: "Orders Completed"},
	{ field: "qualityScore", headerName: "Quality Score"},
	{ field: "timelinessScore", headerName: "Timeliness Score"},
	{ field: "averageDailyOutput", headerName: "Average Daily Output (garments)"},
	{ field: "customerFeedbackScore", headerName: "Customer Feedback Score"},
	{ field: "yearsOfExperience", headerName: "Years of Experience"},
	{ field: "awardsReceived", headerName: "Awards Received"},
	{ field: "goalsForNextQuarter", headerName: "Goals for Next Quarter"},
	{ field: "id", headerName: "id"},
];



  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const staffSnapshot = await getDocs(query(collection(db, "staffMembers"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const staffData = staffSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const staffMap = staffData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.firstName+ " " +ref.lastName }), {});
	setStaffMap(staffMap);



            if (staffData.length === 0) {
	let missing = [];
	if (staffData.length === 0) missing.push("staffmembers");
	setMissingCollections(missing);
	setCollectionModalOpen(true);
}

        };
    
        fetchStaticData();
      }, [appUserAccountNumber, applicationMode]);
    
    
  

  useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const idFromQuery = urlParams.get("id");

  // Only run if there's an ID in the URL and tasks are already loaded
  if (idFromQuery && !loading && tailorPerformances.length > 0) {

    const matchedRecord = tailorPerformances.find(tailorPerformance => tailorPerformance.id === idFromQuery);
    window.history.replaceState({}, document.title, window.location.pathname);
    if (matchedRecord) {
      handleOpenEdit(idFromQuery);
    }
  }
}, [loading, tailorPerformances]);


  useEffect(() => {
    if (!appUserAccountNumber || !applicationMode) return; // Ensure both values are available

    const tailorPerformancesRef = collection(db, "tailorPerformances");
    const tailorPerformancesQuery = query(tailorPerformancesRef, 
      where("appAccountNumber", "==", appUserAccountNumber),
      where("applicationMode", "==", applicationMode)
    );
  
    const unsubscribe = onSnapshot(tailorPerformancesQuery, (snapshot) => {
      const tailorPerformancesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setTailorPerformances(tailorPerformancesData);
      







      setLoading(false);

    }, (error) => {
      setLoading(false);
      alert("Error fetching tailorperformances: ", error);
    });

    return () => unsubscribe();
  }, [appUserAccountNumber, applicationMode]);




//USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  






}, [theme.palette.mode, tailorPerformances ]);

const handleDeleteSelected = async () => {
  if (deleteSelectionModel.length === 0) {
    setDeleteAlertOpen(true);
    return;
  } else 
  {

    setProcessing(true);
    const idsToDelete = [];
    const idsNotToDelete = [];

    let allDeletionDependencies = [];

    //1. Identify Ids to Delete
    for (const id of deleteSelectionModel)
    {
      const dependencies = await hasDependencies(id);
  
      allDeletionDependencies = allDeletionDependencies.concat(dependencies); 

      setProcessing(false);
      
      if (dependencies.length === 0) {
        idsToDelete.push(id);
      } else 
      {
        idsNotToDelete.push(id);
      }
    }

    let uniqueDeletionDependencies = [...new Set(allDeletionDependencies)];

    setDeletionDependencies(uniqueDeletionDependencies);

    setSelectedIdsToDelete(idsToDelete);
    setSelectedIdsNotToDelete(idsNotToDelete);

    //2. Delete allowed ids

    setDeleteConfirmOpen(true);
    setProcessing(false);

  }

};


  const confirmDeleteSelected = async () => {
    try {
      const batch = writeBatch(db);
      selectedIdsToDelete.forEach(id => {
        const docRef = doc(db, "tailorPerformances", id);
        batch.delete(docRef);
        
      });

      await batch.commit();
      logToast("The records have been delete.");

      setDeleteSelectionModel([]);
      setDeleteConfirmOpen(false);
    } catch (error) {
      console.error("Error deleting documents: ", error);
    }
  };

  const openTailorPerformanceDrawer = (id) => {

    const rowIndex = filteredTailorPerformances.findIndex(row => row.id === id);

    const tailorPerformanceId = id;

    setSelectedRowIndex(rowIndex);

    const selectedTailorPerformance = tailorPerformances.find(p => p.id === tailorPerformanceId);
    if (selectedTailorPerformance !== null && selectedTailorPerformance != undefined)
    {  
      setSelectedTailorPerformance(selectedTailorPerformance);
      setDrawerOpen(true);
    }
  };

  const handleDrawerClose = () => {
      setDrawerOpen(false);
      setSelectedTailorPerformance(null);
  };

  const handleArrowUpClick = () => {
    
    if (selectedRowIndex > 0) {
      const item = filteredTailorPerformances[selectedRowIndex - 1];
      openTailorPerformanceDrawer(item.id);
    }
      
  };

  const handleArrowDownClick = () => {
    
    if (selectedRowIndex < filteredTailorPerformances.length - 1) {

      const item = filteredTailorPerformances[selectedRowIndex + 1];
      openTailorPerformanceDrawer(item.id);
    }
      
  };

  const handleCancelDelete = () => {
      
    setDeleteConfirmOpen(false);
    setSelectedIdsToDelete([]);
    setSelectedIdsNotToDelete([]);
    setDeletionDependencies([]);
    
};

  const handleAlertClose = () => {
    setDeleteAlertOpen(false);
  };
  
  const formatFirestoreDate = timestamp => {

    if (timestamp != null && timestamp !== "")
    {
      const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
      const parts = dateStr.split('-');
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    } else 
    {
      return "";
    }
  };

  const formatFirestoreTime = timestamp => {

   if (timestamp != null && timestamp !== "")
   { 
        // Convert the seconds since Unix epoch to a Date object
      const date = new Date(timestamp.seconds * 1000);

      // Extract hours and minutes
      let hours = date.getHours();
      const minutes = date.getMinutes();

      // Determine AM or PM
      const period = hours >= 12 ? 'PM' : 'AM';

      // Convert hours to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'

      // Format hours and minutes as a time string in "hh:mm AM/PM" format
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes} ${period}`;
   } else
   {
    return "";
   }
  };


  const formatPhoneNumber = value => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const formatCurrencyInteger = value => {
  
    if (value != null && value !=="")
    {
      return `$${Number(value).toLocaleString()}`;
    } else 
    {
      return "";
    }
  };

  const formatCurrency = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `$${result}` : '';

      } else 
      {
        return "";
      }
  };


  
 const formatStaff = value => {

    let formattedStaff = "";

    if (value != null && value !=="")
    {
    formattedStaff = staffMap[value];
    }
    
    return formattedStaff;
 };
    
                


  const CustomNoRowsOverlay = () => (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%" sx={{ flexDirection: 'column' }}>
      <img src={noRecordImage} alt="No Data" style={{ width: 250, height: 250, opacity: 0.4 }} />
      <Typography variant="h4" sx={{ color: colors.grey[300] }}>You don't have any tailor performances yet</Typography>
      <Typography variant="h5" sx={{ color: colors.grey[400], padding: '10px' }}>Click the <span style={{ color: '#dc0000', fontWeight: 'bold' }}>"ADD NEW"</span> button above</Typography>
    </Box>
  );

  const openTailorPerformanceEditing = async (tailorPerformance) => {
  
    setEditingTailorPerformance(tailorPerformance); 
    setShowModal(true);

  }
  

  const GridActionsCellItem = ({ id }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      event.stopPropagation();  // Stop the event propagation
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => { setAnchorEl(null); setEditingTailorPerformance(null); };
    const handleDeleteAction = () => { handleDeleteSingleItem(id); };
    const handleEditAction = () => { setEditingTailorPerformance(tailorPerformances.find(tailorPerformance => tailorPerformance.id === id)); setShowModal(true); };
    const handleCloneAction = () => {
      const tailorPerformanceToEdit = tailorPerformances.find(tailorPerformance => tailorPerformance.id === id);
      const clonedTailorPerformance = { ...tailorPerformanceToEdit, id: null, name: `${tailorPerformanceToEdit.name} CLONED` };
      setEditingTailorPerformance(clonedTailorPerformance);
      setShowModal(true);
    };

    return (
      <>
        <IconButton aria-label="more" id="long-button" aria-controls={open ? 'long-menu' : undefined} aria-expanded={open ? 'true' : undefined} aria-haspopup="true" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu id="long-menu" MenuListProps={{ 'aria-labelledby': 'long-button', sx: { backgroundColor: colors.greenAccent[700] , color: colors.grey[100] } }} anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem onClick={handleCloneAction}><FileCopyIcon style={{ marginRight: 8 }} /> Clone Tailor Performance</MenuItem>
          <MenuItem onClick={handleDeleteAction}><DeleteIcon style={{ marginRight: 8 }} /> Delete Tailor Performance</MenuItem>
          <MenuItem onClick={handleEditAction}><EditIcon style={{ marginRight: 8 }} /> Edit Tailor Performance</MenuItem>
        </Menu>
      </>
    );
  };

  const handleScroll = event => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollTop + clientHeight === scrollHeight) setVisibleCount(prevCount => prevCount + 3);
  };

  useEffect(() => {
    const element = document.getElementById('scrollContainer');
    if (element) {
      element.addEventListener('scroll', handleScroll);
      return () => element.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const loadMore = () => setVisibleCount(prevCount => prevCount + 3);
  const handleOpenModal = () => { setEditingTailorPerformance(null); setShowModal(true); };
  const handleCloseModal = () => setShowModal(false);
  const handleSaveTailorPerformance = tailorPerformance => {
    if (editingTailorPerformance && editingTailorPerformance.id) {
      setTailorPerformances(prevTailorPerformances => prevTailorPerformances.map(c => c.id === tailorPerformance.id ? tailorPerformance : c));
      saveTailorPerformanceToDB(tailorPerformance);
    } else {
      setTailorPerformances(prevTailorPerformances => [...prevTailorPerformances, { ...tailorPerformance, id: prevTailorPerformances.length + 1 }]);
      addTailorPerformanceToDB(tailorPerformance);
    }
    setShowModal(false);
    setEditingTailorPerformance(null);

    if (applicationMode === 'test' && !suppressTestModeWarning) {
      setShowTestModeDialog(true);
    }
  };

  const hasDependencies = async (id) => {
    const dependencies = [];
  
    try {
      
      
  
    } catch (error) {
      console.error("Error checking dependencies:", error);
      return ["error"]; // Return an array with "error" to prevent deletion in case of an issue
    }
  
    return dependencies; // Return array of collection names with dependencies
  };
  
  const handleDeleteSingleItem = async (id) => {
  
    try
    {
      
      setProcessing(true);

      const dependencies = await hasDependencies(id);
    
      setProcessing(false);
      
      if (dependencies.length === 0) {
        setDeleteId(id);
        setConfirmOpen(true);
      } else {
        setDeleteId(id);
        setDeletionDependencies(dependencies);
        setDependenciesAlertOpen(true);
      }

    } catch(error)
    {
      setProcessing(false);
    }
  };

  const handleDependenciesAlertClose = async () => {
    
      setDependenciesAlertOpen(false);
      setDeletionDependencies([]);
    
  };


  const handleConfirmClose = async () => {
    try {
      if (deleteId) await deleteDoc(doc(db, "tailorPerformances", deleteId));
      setConfirmOpen(false);
      setDeleteId("");
      logToast("The record has been delete.");
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };
  const handleCancelClose = () => {
    setConfirmOpen(false);
    setDeleteId("");
  };

  const saveTailorPerformanceToDB = async (tailorPerformance) => {
    const tailorPerformanceRef = doc(db, "tailorPerformances", tailorPerformance.id);  // Reference to the document
  
    if (editingTailorPerformance) {
      // Update the existing tailorperformance document
      await updateDoc(tailorPerformanceRef, tailorPerformance)
        .then(() => {
          logToast("The record has been saved.");
          console.log("Document successfully updated!");
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
        });
    } else {
      // Add new tailorPerformance logic if needed
    }
  
  };
  
  const addTailorPerformanceToDB = async (tailorPerformance) => {
    
    const tailorPerformanceNumber= await generateUniqueId("tailorPerformances",appUserAccountNumber);
    tailorPerformance.tailorPerformanceNumber = tailorPerformanceNumber;

    tailorPerformance.appAccountNumber = appUserAccountNumber;
    tailorPerformance.applicationMode = applicationMode;

    const docRef = doc(db, 'tailorPerformances', tailorPerformanceNumber);  
    await setDoc(docRef,tailorPerformance);
    logToast("The record has been added.");
  };

  const handleOpenEdit = (id) => {

    setEditingTailorPerformance(tailorPerformances.find(tailorPerformance => tailorPerformance.id === id));
    setDrawerOpen(false);
    setShowModal(true); 
  }

  
  const StyledCard = styled(Card)(({ theme, colors, isMobile }) => ({
    maxWidth: isMobile ? 320 : 270,  // this only for non avatar, for avatar maxWidth:300 is good
    minWidth: isMobile ? 'initial' : 250,
    margin: '10px',
    padding: '10px',
    //borderRadius: '10px',
    //boxShadow: '0 24px 48px rgba(0, 0, 0, 0.1)',
    border: `1px solid ${colors.tile.borderColor}`,
    textAlign: 'center',
    position: 'relative',
    //backgroundColor: '#f1f1f1', // Light background color for contrast
  
    backgroundColor: colors.tile.backGroundColor,//#2c2c2c // Prompt:What is a blue like color that can be used to replace this tile background color, which is currently #2c2c2c
    borderRadius: '10px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    '& .MuiAvatar-root': {
      width: '60px',
      height: '60px',
      margin: '0 auto 10px',
      backgroundColor: colors.tile.borderColor, // Vibrant color for avatar background
    },
    '& .MuiTypography-root': {
      color: colors.tile.color, // Vibrant color for text
    },
    '& .MuiButton-root': {
      backgroundColor: colors.tile.backGroundColor, // Vibrant color for button background
      color: '#fff',
      '&:hover': {
        backgroundColor: colors.tile.backGroundColor,
      },
    },
    '& .MuiDivider-root': {
      backgroundColor: colors.tile.borderColor, // Vibrant color for divider
    },
    '& .details': {
      marginBottom: '8px',
    },
  }));

  /*
  const filteredTailorPerformances = tailorPerformances.filter(tailorPerformance =>
    columns.some(column => tailorPerformance[column.field] && tailorPerformance[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
  );
  */

  
  const filteredTailorPerformances = tailorPerformances.filter(tailorPerformance =>
    filteringColumns.some(column => {
        let value = tailorPerformance[column.field];

        let matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());

        if (matchFound == false)
        {
          if (column.field.endsWith('Id')) {
              const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());

              try
              {
                value = eval(`${formatFunctionName}("${value}")`);
                matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());
              } catch(errr){}
          }
        }

        return matchFound;

    })
  );

  const totalTailorPerformances = filteredTailorPerformances.length;

  return (
    <div>

    <Box m="20px"
    style={{
      margin: '20px',
      backgroundImage: isMobile ? `url(${backgroundImageMobile})` : `url(${backgroundImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top right',
      paddingBottom:'10px',
      //backgroundSize: 'contain',
      //opacity: 0.1, // Adjust the opacity as needed
    }}
  >
          <Header title="Tailor Performances" subtitle="List of tailor performances" />
       
          <Box m="0px 0 0px 0" display="flex" justifyContent="flex-start" style={{paddingTop:'10px'}}>
              <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleDeleteSelected} disabled={loading}>
                <RemoveCircleOutlineIcon /> &nbsp; Delete Selected
              </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
              <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleOpenModal} disabled={loading}>
                <AddCircleOutlineIcon /> &nbsp; Add New
              </Button>
            </Box>

      {!isMobile ? (
          <Box m="0px 0 0 0" height="75vh" sx={{ "& .MuiDataGrid-root": { border: "none" }, "& .MuiDataGrid-cell": { borderBottom: "none" }, "& .name-column--cell": { color: colors.greenAccent[300] }, "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[700], borderBottom: "none" }, "& .MuiDataGrid-virtualScroller": { ...(tailorPerformances.length > 0 && { backgroundColor: colors.primary[400] }), '::-webkit-scrollbar': { width: '7px', height: '7px' } }, "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[700] }, "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` }, "& .MuiDataGrid-toolbarContainer .MuiButton-text": { color: `${colors.grey[100]} !important` } }}>

            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress size={150} style={{ color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }}  />
              </Box>
            ) : (
            <DataGrid checkboxSelection rows={filteredTailorPerformances} columns={columns} components={{ Toolbar: GridToolbar, NoRowsOverlay: CustomNoRowsOverlay }} disableSelectionOnClick onRowClick={(params) => openTailorPerformanceDrawer(params.id)}
            sx={{
              '& .MuiDataGrid-columnHeaderTitle': {
                fontSize: '14px',
                ...(theme.palette.mode !== 'dark' && {
                fontWeight: 'bold',
              }),
              },
              '& .MuiDataGrid-main': {
                ...(theme.palette.mode !== 'dark' && {
                borderBottom: `1px solid ${colors.tableHeaderBorderColor}`,
              }),
              },
              '& .MuiDataGrid-columnHeaders': { 
                ...(theme.palette.mode !== 'dark' && {
                borderTop: `1px solid ${colors.tableHeaderBorderColor}`,
                borderBottom: `1px solid ${colors.tableHeaderBorderColor}`,
              }),
              },
                // Red bottom border for footer
              '& .MuiDataGrid-footerContainer': {
                ...(theme.palette.mode !== 'dark' && {
                borderBottom: `1px solid ${colors.tableHeaderBorderColor}`,
              }),
              },
              '& .MuiDataGrid-cell': {
                borderBottom: `1px solid ${colors.tableRowBottomBorberColor}`,
              },
              '& .MuiDataGrid-cell--editable': {
                borderBottom: `1px solid ${colors.tableRowBottomBorberColor}`,
              },
              '& .MuiDataGrid-cell:focus, .MuiDataGrid-cell:focus-within': {
                borderBottom: `1px solid ${colors.tableRowBottomBorberColor}`,
                borderTop: 'none',
                borderLeft: 'none',
                borderRight: 'none',
              },
              '& .MuiDataGrid-cell--selected': {
                borderBottom: `1px solid ${colors.tableRowBottomBorberColor}`,
              },
              '& .MuiDataGrid-cell:focus-within': {
                outline: 'none',
              },
            }}
               onSelectionModelChange={(newDeleteSelection) => {
                setDeleteSelectionModel(newDeleteSelection);
              }}
              selectionModel={deleteSelectionModel}
  
            />
          )}
          </Box>
       
      ) : (

        <div>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%" sx={{paddingTop:'100px'}}>
            <CircularProgress size={150} style={{ color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }}  />
          </Box>
        ) : (

          <div> 
            
          {!loading &&

            <div className="tile-wrapper">

              {filteredTailorPerformances.slice(0, visibleCount).map((item, index) => ( 
                    <Tile key={index} data={item} tailorPerformances={tailorPerformances} setShowModal={setShowModal} setEditingData={setEditingTailorPerformance} handleDeleteSingleItem={handleDeleteSingleItem} setCollectionModalOpen={setCollectionModalOpen} setMissingCollections={setMissingCollections} deleteSelectionModel={deleteSelectionModel} setDeleteSelectionModel={setDeleteSelectionModel} />
                    ))}
          
          
              </div>
           }

          {visibleCount < totalTailorPerformances && 

                            
          <Box variant="contained" sx={{textAlign:'center'}}>
            <Button onClick={loadMore} variant="contained" sx={{ m: 2, alignSelf: 'center', backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}>Load More</Button>
            <br></br>
            <br></br>
          </Box> 

          }

        {visibleCount >= totalTailorPerformances && <br />}
        {tailorPerformances.length === 0 && (
          <Box display="flex" alignItems="center" justifyContent="center" height="100%" sx={{ flexDirection: 'column' }}>
            <img src={noRecordImage} alt="No Data" style={{ width: 250, height: 250, opacity: 0.4 }} />
            <Typography variant="h4" sx={{ color: colors.grey[300] }}>You don't have any tailor performances yet</Typography>
            <Typography variant="h5" sx={{ color: colors.grey[400], padding: '10px' }}>Click the <span style={{ color: '#dc0000', fontWeight: 'bold' }}>"ADD NEW"</span> button above</Typography>
          </Box>
        )}
           </div>
        )}
        </div>
        
      )}
    </Box>

    <TailorPerformanceDrawerModal
                        drawerOpen={drawerOpen}
                        handleDrawerClose={handleDrawerClose} 
                        handleArrowUpClick={handleArrowUpClick} 
                        handleArrowDownClick={handleArrowDownClick}
                        selectedTailorPerformance={selectedTailorPerformance}
                        tailorPerformances={tailorPerformances} 
                        handleOpenEdit={handleOpenEdit}
                    />

      <TailorPerformanceInputModal isOpen={showModal} onClose={handleCloseModal} onSave={handleSaveTailorPerformance} tailorPerformance={editingTailorPerformance} />
      <Dialog open={confirmOpen} onClose={handleCancelClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this tailor performance?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
            No
          </Button>
          <Button onClick={handleConfirmClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={collectionModalOpen} aria-labelledby="collection-modal-title" aria-describedby="collection-modal-description">
        <DialogTitle id="collection-modal-title">{"Missing Records"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="collection-modal-description">
            {missingCollections.includes("staffmembers") && <span>Please add at least one <b>staff member</b> before managing tailor performances. <br></br></span>}

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}  onClick={() => window.location.href = `/${missingCollections[0]}`} color="primary">
            Go to {missingCollections[0]}
          </Button>
        </DialogActions>
      </Dialog>


    <Dialog open={deleteConfirmOpen} onClose={handleCancelDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm Delete"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            
          
            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length == 0) && 
              <div>Are you sure you want to delete the selected tailor performances? </div>
            }

            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected tailor performances with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>

                However, the remaining tailor performances with ids: &nbsp; 
                <b>{selectedIdsToDelete.join(", ")}</b><br></br> 
                will be deleted If you select <b>YES</b>. <br></br><br></br>

                Do you want to proceed deleting <b>{selectedIdsToDelete.join(", ")}</b>? 
              </div>
            }

            {(selectedIdsToDelete.length == 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected tailor performances with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>
                Please remove these dependencies before proceeding with the deletion.
                <br></br><br></br>

                <b><u>TIP</u>:</b> You can go to each of the components listed above and type each of the ids listed one by one in the search box to find the dependent records.                
              </div>
            }

          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelDelete} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
          {selectedIdsToDelete.length > 0 ? 'No' : 'OK'}
          </Button>
          {selectedIdsToDelete.length > 0 &&
          <Button onClick={confirmDeleteSelected} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
          }
        </DialogActions>
      </Dialog>
      
      <Dialog open={deleteAlertOpen} onClose={handleAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            No tailor performances selected for deletion.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dependenciesAlertOpen} onClose={handleDependenciesAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Delete Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
          This tailor performance cannot be deleted because it is linked <br></br> 
          to other dependent records in the following components:<br></br> <br></br>
          <b>{deletionDependencies.join(", ")}</b>. 
          <br></br><br></br>
          Please remove these dependencies before proceeding with the deletion.
          <br></br><br></br>

          <b><u>TIP</u>:</b> You can go to each of the components listed above and type <b>{deleteId}</b> in the search box to find the dependent records.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleDependenciesAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showTestModeDialog} onClose={() => setShowTestModeDialog(false)}>
  <DialogTitle sx={{ backgroundColor: colors.greenAccent[700] }}>
    {"Test Mode Notice"}
  </DialogTitle>
  <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
    <DialogContentText>
      You are currently in <strong>Test Mode</strong>. This mode is intended for training and testing purposes only.
      <br /><br />
      If your intention is to add a live project record, please turn off test mode before proceeding.
    </DialogContentText>
    <Box mt={2}>
      <label>
        <input
          type="checkbox"
          checked={suppressTestModeWarning}
          onChange={(e) => {
            const checked = e.target.checked;
            setSuppressTestModeWarning(checked);
            localStorage.setItem('suppressTestModeSaveWarning', checked);
          }}
        />{" "}
        Don't show this message again when saving in test mode
      </label>
    </Box>
  </DialogContent>
  <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
    <Button
      onClick={() => setShowTestModeDialog(false)}
      sx={{
        backgroundColor: colors.greenAccent[600],
        color: colors.primary[100],
        '&:hover': { backgroundColor: colors.greenAccent[800] }
      }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>
      
    {processing && (
      <Box
        position="fixed"
        top={0}
        left={0}
        width="100%"
        height="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        zIndex={2000}
        pointerEvents="none"
      >
        <CircularProgress size={120} style={{ color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }} />
      </Box>
    )}

    </div>
  );
};

export default TailorPerformances;
